import hotkeys from "./embedded_extlibs/hotkeys.js"
import keyBinderEvents from "./key_binder_events.js"
import alias from "./alias.js"

console.warn('Toxilib "key_binder" will be deprecated. Use "input_observer" instead !')


let globalScope = "all"

function KeyBinder (scope, element) {
    this.scope = scope || globalScope

    if (element) {
        this.element = element
    }

    this.clear()
    keyBinderEvents(this)
}


KeyBinder.prototype.onPressed = function (keys, handler) {
    let self = this
    function listener (event, data) {
        handler.call(self, event, data)
    }

    hotkeys(keys, listenerParams(this), listener)

    return listener
}


KeyBinder.prototype.onReleased = function (keys, handler) {
    let self = this
    function listener (event, data) {
        handler.call(self, event, data)
    }

    hotkeys(keys, listenerParams(this, {keyup: true}), listener)

    return listener
}


KeyBinder.prototype.isPressed = function (key) {
    return KeyBinder.isPressed(key)
}


KeyBinder.prototype.unbind = function (keys, listener) {
    hotkeys.unbind(keys, this.scope, listener)
}


KeyBinder.prototype.pressedKeyCodes = function () {
    return KeyBinder.pressedKeyCodes()
}


KeyBinder.prototype.clear = function () {
    let isActive = KeyBinder.isActiveScope(this.scope)
    hotkeys.deleteScope(this.scope)

    if (isActive) {
        KeyBinder.setScope(this.scope)
    }
}



KeyBinder.isPressed = function (key) {
    return hotkeys.isPressed(key)
}


KeyBinder.pressedKeyCodes = function () {
    return hotkeys.getPressedKeyCodes()
}



KeyBinder.getScope = function () {
    return hotkeys.getScope()
}


KeyBinder.isActiveScope = function (scope) {
    return this.getScope() === scope
}


KeyBinder.setScope = function (scope) {
    hotkeys.setScope(scope)
}


KeyBinder.setScope(globalScope)




let globalKeyBinder = new KeyBinder()

alias({
    proxy: KeyBinder,
    target: globalKeyBinder,
    keys: [
        "onPressed",
        "onReleased",
        "unbind",
        "clear",
        "on",
        "emit",
        "removeListener",
        "removeAllListenersFor",
        "removeAllListeners",
        "emitter"
    ]
})





function listenerParams (keyboard, extension) {
    let params = {
        scope: keyboard.scope
    }

    if (keyboard.element) {
        params.element = keyboard.element
    }

    if (extension) {
        for (let prop in extension) {
            params[prop] = extension[prop]
        }
    }

    return params
}


export default KeyBinder